<template>
  <b-carousel-slide v-editable="blok" class="slide">
    <div class="slide-container">
      <component
        :key="index"
        v-for="(child,index) in blok.content"
        :blok="child"
        :is="child.component"
      >
      </component>
    </div>
  </b-carousel-slide>
</template>
<script>
export default {
  name: "slideshow-slide",
  props: ["blok"],
};
</script>
